import SubViewOptions from '../SubViewOptions';
import SearchSimple from '../../../../../../components/SearchSimples/SearchSimple';
import React from 'react';
import CustomExpandableTable from '../../../../../../components/table/CustomExpandableTable';
import { permissionObj } from '../../../../../../Helpers/permission';
import NotInformation from '../../../../../../components/NotInformation';
import CustomButtonLink from '../../../../../../components/buttons/CustomButtonLink';
import routes from '../../../../../../Routes/routes';
import ShiftAccessApp from './Functionality/ShiftAccessApp';
import DeleteModal from '../../../../../Modals/DeleteModal';
import {ATTENDANCE_SUBVIEW_MODEL, TABS_ATTENDANCE} from '../../Model/Model';
import RenderDetails from "./SubComponents/RenderDetails";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ShiftAccess = (
    {
        registerAction,
        subView,
        option,
        changeSubViewManage,
        selectForDelete, setSelectForDelete,

        setBodyForExport,
        searchElement, setSearchElement,
        setSimpleSearch,
        search, setSearch
    }
) => {


    const {
        t,
        DEV, permission,navigate,
        searchId,
        deleteModalShow, setDeleteModalShow,
        searchResults, setSearchResults,
        page, rowsPerPage,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        columns,
        RenderOptionsMenu,
        showOptionsMenu,
        canDelete,
        fnDelete
    } = ShiftAccessApp(
        {
            registerAction,
            option,
            selectForDelete,
            setSelectForDelete,
            searchElement,
            setSimpleSearch,
        }
    );
    return (
        <>
            <div className="d-flex">
                <SubViewOptions
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                />
                <div className='w-100 ml-4'>
                    <SearchSimple
                        id={searchId}
                        setBodyForExport={setBodyForExport}
                        setSearchResults={setSearchResults}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        page={page}
                        rowsPerPage={rowsPerPage}
                        setSimpleSearch={setSimpleSearch}
                        search={search}
                        setSearch={setSearch}
                        contractorId={null}
                        supplierId={null}
                    />
                </div>
            </div>


            {searchResults?.content?.length > 0 ?
                <>
                    {/**Done*/}
                    <CustomExpandableTable
                        columns={columns}
                        rows={searchResults?.content}
                        renderExpandedRow={RenderDetails}
                        renderOptionsMenu={showOptionsMenu ? RenderOptionsMenu : false}
                        checkbox={canDelete}
                        onRowExpand={handleRowExpand}
                        selectedList={selectForDelete}
                        handleCheckboxChange={handleCheckboxChange}
                        handleDeleteAll={handleDeleteAll}
                        rowsPerPage={rowsPerPage}
                    />
                    {pagination()}
                </>
                :
                <NotInformation card={true} className={"mt-4"}>
                    <>
                        <div className="warning-text">
                            <p>{t("you_have_not_created_any_shifts_access_yet")}</p>
                        </div>
                        {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_CREATE)) &&
                            <CustomButtonLink
                                className={'d-block'}
                                splitName={false}
                                id="btn_saa_create_shift_access"
                                card={true}
                                name="add_new_shift_access"
                                onClick={()=>{
                                    navigate(routes.attendanceShiftAccess.add, {
                                        state: {
                                            currentTab: TABS_ATTENDANCE.MANAGE.INDEX,
                                            currentSubView: ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS,
                                        },
                                    });
                                }}
                            />
                        }
                    </>
                </NotInformation>
            }


            {deleteModalShow &&
                <DeleteModal
                    title_modal={'delete_shift_access'}
                    show={deleteModalShow}
                    onHide={() => {
                        setDeleteModalShow(false);
                    }}
                    onClickFn={() => {
                        fnDelete();
                    }}
                    buttonCancelText='cancel'
                    data={selectForDelete}
                    isReset={setSelectForDelete}
                    description={'are_you_sure_you_want_to_delete'}
                    element_modal={t("shift_access")
                    }
                />
            }

        </>
    );
}

export default ShiftAccess
